import request from '@/utils/request'; // 获取报修列表

export function fetchList(data) {
  return request({
    url: '/pmsservice/api/repairManage/list',
    method: 'post',
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/repairManage/insert',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/repairManage/get',
    method: 'post',
    data: data
  });
} // 工单号明细

export function flowNumDetail(data) {
  return request({
    url: '/pmsservice/api/repairManage/getRepairManageInfoByFlowNum',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/pmsservice/api/repairManage/delete',
    method: 'post',
    data: data
  });
} // 编辑

export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/repairManage/update',
    method: 'post',
    data: data
  });
} // 房间代码

export function fetchHouseCode(data) {
  return request({
    url: '/pmsservice/api/repairManage/selectHouseCodeList',
    method: 'post',
    data: data
  });
} // 派工

export function dispatchOrder(data) {
  return request({
    url: '/pmsservice/api/repairManage/distributeLeaflets',
    method: 'post',
    data: data
  });
} // 完成

export function repairFinish(data) {
  return request({
    url: '/pmsservice/api/WxRepairManage/serverFinish',
    method: 'post',
    data: data
  });
} // 转派

export function repairRedeploy(data) {
  return request({
    url: '/pmsservice/api/WxRepairManage/transferRepairOrder',
    method: 'post',
    data: data
  });
} // 审核确认

export function repairConfirm(data) {
  return request({
    url: '/pmsservice/api/WxRepairManage/confirmOrder',
    method: 'post',
    data: data
  });
} // 回访评价

export function evaluate(data) {
  return request({
    url: '/pmsservice/api/repairManage/appraiseReturn',
    method: 'post',
    data: data
  });
} // 归档

export function repairArchive(data) {
  return request({
    url: '/pmsservice/api/repairManage/orderToFiled',
    method: 'post',
    data: data
  });
} // 派工人员列表

export function userList(data) {
  return request({
    url: '/pmsservice/api/repairManage/selectSysUserList',
    method: 'post',
    data: data
  });
} // 获取系统设备列表

export function deviceList(data) {
  return request({
    url: '/pmsservice/api/repairManage/selectSysDeviceList',
    method: 'post',
    data: data
  });
} // 获取工单子类列表

export function fetchOrderList(upDicValue) {
  var data = {
    upDicValue: upDicValue
  };
  return request({
    url: '/pmsservice/api/repairManage/linkOrderSubList',
    method: 'post',
    data: data
  });
}